import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export default function RedirectIfAuthenticated() {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return null
  }

  if (user) {
    // Redirect to the page they came from, or dashboard by default
    const state = location.state as { from?: { pathname: string } } | null
    return <Navigate to={state?.from?.pathname ?? '/dashboard'} replace />
  }

  return <Outlet />
}
